import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import TemplateRenderer from './TemplateRenderer';

const WorkshopLanding = () => {
  const { slug } = useParams();
  const [workshop, setWorkshop] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let subscription;

    const fetchWorkshopData = async () => {
      try {
        const { data, error } = await supabase
          .from('workshops')
          .select('*')
          .eq('slug', slug)
          .single();
        if (error) throw error;
        setWorkshop(data);

        if (data && data.id) {
          subscription = supabase
            .channel(`workshop-changes-${data.id}`)
            .on(
              'postgres_changes',
              {
                event: 'UPDATE',
                schema: 'public',
                table: 'workshops',
                filter: `id=eq.${data.id}`,
              },
              (payload) => {
                console.log('Actualizacion en tiempo real:', payload);
                setWorkshop((prev) => ({ ...prev, ...payload.new }));
              }
            )
            .subscribe();
        }
      } catch (error) {
        console.error('Error cargando datos:', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchWorkshopData();

    return () => {
      if (subscription) {
        supabase.removeChannel(subscription);
      }
    };
  }, [slug]);

  if (loading) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #070714 0%, #0f0a1e 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid rgba(139,92,246,0.3)', borderTopColor: '#8b5cf6', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
        <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>Cargando...</p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  if (!workshop) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #070714 0%, #0f0a1e 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: 'rgba(255,255,255,0.5)' }}>Pagina no encontrada.</p>
    </div>
  );

  return <TemplateRenderer workshopData={workshop} />;
};

export default WorkshopLanding;
